import styles from './YellowNoteCard.module.scss';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Box,
  Card,
  CardContent,
  Collapse,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import clsx from 'clsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { YellowNoteFooter } from './components/YellowNoteFooter';
import { useYellowNoteContext } from './yellow-note-context';

export const YellowNoteCard = () => {
  const { t } = useTranslation();

  const context = useYellowNoteContext();

  const { data: note } = context;

  const [expanded, setExpanded] = useState<boolean>(false);

  return (
    <Card className={styles.card}>
      <Stack
        className={clsx(styles.titleWrapper, {
          [styles.titleWrapperExpanded]: expanded,
        })}
      >
        <Box display="flex" width="100%">
          <Typography className={styles.title} variant="h4">
            {t('FILE.YELLOW_NOTE.TITLE')}
          </Typography>
          <Box className={styles.titlePreviewWrapper}>
            <Typography
              className={styles.titlePreview}
              variant="body2"
              noWrap
              title={note?.body?.split('\n')[0]}
            >
              {!expanded && note?.body
                ? `| ${note?.body?.split('\n')[0]}`
                : null}
            </Typography>
            {!expanded && note?.body && (
              <Typography variant="body2">...</Typography>
            )}
          </Box>
        </Box>
        <IconButton size="small" onClick={() => setExpanded(!expanded)}>
          {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Stack>

      <Collapse in={expanded}>
        <CardContent className={styles.cardContent}>
          <div className={clsx(styles.body, 'custom-scrollbar')}>
            {note?.body ?? ''}
          </div>
        </CardContent>
        <YellowNoteFooter note={note} />
      </Collapse>
    </Card>
  );
};
